import { render } from "./IntentionSetterV1Navigation.vue?vue&type=template&id=060c594e&scoped=true"
import script from "./IntentionSetterV1Navigation.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1Navigation.vue?vue&type=script&lang=js"

import "./IntentionSetterV1Navigation.vue?vue&type=style&index=0&id=060c594e&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060c594e"]])

export default __exports__